import { resolveStoredFileUrl } from "utils/storedFileUrl";
// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import { CircularProgress, Icon, Tooltip } from "@mui/material";

// Kaizen Dashboard components
import SoftBadge from "components/SoftBadge";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import dayjs from "dayjs";
import { useContext, useRef } from "react";
import { MessageManager } from "context";

function DocumentacionItem({
  name,
  description,
  value,
  handleDelete,
  saveFile,
  file,
  handleOpenMotivo,
  loading,
}) {
  const fileRef = useRef();
  const { handleSnackbar } = useContext(MessageManager);

  return (
    <SoftBox key={name} py={1}>
      <SoftBox display="flex" justifyContent="space-between" alignItems="center">
        <SoftBox
          display={{
            xs: "flex-row",
            sm: "flex",
          }}
          alignItems="center"
          sx={{
            cursor: "pointer",
          }}
        >
          <Tooltip
            title={
              file.url && file.estado === "Aprobado"
                ? "El archivo fue aprobado"
                : file.url && file.estado === "Rechazado"
                  ? "El archivo fue rechazado"
                  : file.url && file.estado === "Pendiente"
                    ? "El archivo está pendiente de revisión"
                    : file.url && !file.estado
                      ? "Archivo subido"
                      : "No hay ningún archivo seleccionado"
            }
            placement="top"
          >
            <SoftButton
              iconOnly
              circular
              color={
                file.url && file.estado === "Aprobado"
                  ? "success"
                  : file.url && file.estado === "Rechazado"
                    ? "error"
                    : file.url && file.estado === "Pendiente"
                      ? "warning"
                      : file.url && !file.estado
                        ? "info"
                        : "secondary"
              }
            >
              <Icon fontSize="medium">
                {file.url && file.estado === "Aprobado"
                  ? "done"
                  : file.url && file.estado === "Rechazado"
                    ? "close"
                    : file.url && file.estado === "Pendiente"
                      ? "pending_actions"
                      : file.url && !file.estado
                        ? "file_upload"
                        : "attach_file"}
              </Icon>
            </SoftButton>
          </Tooltip>
          <SoftBox
            display="flex"
            flexDirection="column"
            ml={{
              xs: 0,
              sm: 1,
            }}
            mt={{
              xs: 1,
              sm: 0,
            }}
          >
            <SoftBox
              display={{
                xs: "flex-row",
                sm: "flex",
              }}
              alignItems="center"
              sx={{
                lineHeight: "normal",
              }}
            >
              <Tooltip placement="top" title={file?.nombre}>
                <SoftTypography variant="h7" fontWeight="medium">
                  {name.length > 80 ? `${name.substring(0, 80)}...` : name}
                </SoftTypography>
              </Tooltip>
              {file?.fechaVencimiento ? (
                <SoftBox
                  display="flex"
                  alignItems="center"
                  mb={1}
                  mt={{
                    xs: 1,
                    sm: 0,
                  }}
                  ml={{
                    xs: 0,
                    sm: 1,
                  }}
                >
                  <SoftBadge
                    badgeContent={`Vence el ${dayjs(file?.fechaVencimiento).format("DD/MM/YYYY")}`}
                    color={
                      dayjs(file?.fechaVencimiento).isSame(dayjs(), "day")
                        ? "secondary"
                        : dayjs(file?.fechaVencimiento).isBefore(dayjs().subtract(1, "day"))
                          ? "error"
                          : dayjs(file?.fechaVencimiento).isBefore(dayjs().add(30, "day"))
                            ? "warning"
                            : "success"
                    }
                  />
                </SoftBox>
              ) : null}
            </SoftBox>
            <SoftTypography
              variant="caption"
              mt={{
                xs: 1,
                sm: 0,
              }}
              fontWeight={file?.obligatorio && !value && !file.url ? "medium" : "regular"}
              color={file?.obligatorio && !value && !file.url ? "primary" : "text"}
            >
              {description}
            </SoftTypography>
          </SoftBox>
        </SoftBox>
        <SoftBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          ml={{
            xs: 2,
            sm: 0,
          }}
        >
          {file.url ? (
            <SoftBox display="flex">
              {file.estado === "Rechazado" && (
                <SoftBox mr={1}>
                  <Tooltip title={file.comentario} placement="top">
                    <SoftButton
                      color="primary"
                      circular
                      sx={{
                        display: {
                          xs: "none",
                          sm: "flex",
                        },
                      }}
                      onClick={handleOpenMotivo}
                    >
                      Motivo de rechazo &nbsp;
                      <Icon sx={{ fontWeight: "bold" }}>error_outline</Icon>
                    </SoftButton>
                  </Tooltip>
                </SoftBox>
              )}
              <SoftBox mr={1}>
                <Tooltip title="Eliminar Documento" placement="top">
                  <SoftButton
                    color="error"
                    circular
                    iconOnly
                    onClick={() => handleDelete(file.id)}
                    // disabled={
                    //   (file.url &&
                    //     (file.estado === "Aprobado" || file.estado === "Pendiente") &&
                    //     (
                    //       !file?.fechaVencimiento ||
                    //       dayjs().isBefore(dayjs(file?.fechaVencimiento).subtract(10, "day"))
                    //     )) ||
                    //   loading === file.id
                    // }
                  >
                    {loading === file.id ? (
                      <CircularProgress size={15} color="white" />
                    ) : (
                      <Icon sx={{ fontWeight: "bold" }}>delete</Icon>
                    )}
                  </SoftButton>
                </Tooltip>
              </SoftBox>
              <SoftBox>
                <Tooltip title="Descargar" placement="top">
                  <SoftButton
                    color="info"
                    circular
                    iconOnly
                    onClick={async () => {
                      const archivo = await fetch(resolveStoredFileUrl(file.url));
                      const blob = await archivo.blob();
                      const url = URL.createObjectURL(blob);

                      const a = document.createElement("a");
                      a.href = url;
                      a.download = name;
                      a.click();
                    }}
                  >
                    <Icon sx={{ fontWeight: "bold" }}>download</Icon>
                  </SoftButton>
                </Tooltip>
              </SoftBox>
            </SoftBox>
          ) : (
            <SoftBox>
              <Tooltip title="Agregar (Límite 30mb)" placement="top">
                <SoftButton
                  color="uproGreen"
                  circular
                  onClick={() => {
                    fileRef.current.value = null;
                    fileRef.current.click();
                  }}
                  sx={{
                    display: {
                      xs: "none",
                      sm: "flex",
                    },
                  }}
                >
                  Subir archivo &nbsp;
                  <Icon sx={{ fontWeight: "bold" }}>upload</Icon>
                </SoftButton>
              </Tooltip>
              <Tooltip title="Agregar (Límite 30mb)" placement="top">
                <SoftButton
                  color="uproGreen"
                  circular
                  onClick={() => {
                    fileRef.current.value = null;
                    fileRef.current.click();
                  }}
                  iconOnly
                  sx={{
                    display: {
                      xs: "flex",
                      sm: "none",
                    },
                  }}
                >
                  <Icon sx={{ fontWeight: "bold" }}>upload</Icon>
                </SoftButton>
              </Tooltip>
              <input
                ref={fileRef}
                type="file"
                style={{ display: "none" }}
                accept=".pdf, .docx, .jpg, .jpeg, .png"
                onChange={(e) => {
                  const file = e.target.files[0];
                  const maxSizeInBytes = 35 * 1024 * 1024;

                  if (!file || file.size > maxSizeInBytes) {
                    handleSnackbar("El archivo es muy pesado", "error");
                    fileRef.current.value = null;
                    return;
                  };

                  saveFile(file);
                }}
              />
            </SoftBox>
          )}
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
}

// Typechecking props of the DocumentacionItem
DocumentacionItem.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  value: PropTypes.string.isRequired,
  handleDelete: PropTypes.func,
  saveFile: PropTypes.func,
  file: PropTypes.object,
  handleOpenMotivo: PropTypes.func,
  loading: PropTypes.bool,
};

export default DocumentacionItem;
